<template>
  <div class="flex items-center justify-center">
    <p :class="displayClasses" style="height: 30px; width: 30px; text-shadow: 1px 1px 3px #999"
      :title="titleText">{{ displayValue }}</p>
  </div>
</template>
<script>
import { defineComponent } from "@vue/runtime-core";

const STATES = {
  indate: {
    label: "✓",
    title: "In Date",
    classes: "shadow text-center px-2 bg-gradient-to-br from-green-300 to-green-400 rounded-full text-white flex items-center justify-center text-sm",
  },
  overdue: {
    label: "✗",
    title: "Overdue",
    classes: "shadow text-center px-2 bg-gradient-to-br from-red-300 to-red-400 rounded-full text-white flex items-center justify-center text-sm",
  },
  incomplete: {
    label: "–",
    title: "Incomplete",
    classes: "shadow text-center px-2 bg-gradient-to-br from-gray-200 to-gray-300 rounded-full text-gray-500 flex items-center justify-center text-sm",
  },
};

export default defineComponent({
  name: "TrainingStatusValue",
  computed: {
    state() {
      const val = (this.params.value || "incomplete").toLowerCase();
      return STATES[val] || STATES.incomplete;
    },
    displayValue() {
      return this.state.label;
    },
    displayClasses() {
      return this.state.classes;
    },
    titleText() {
      return this.state.title;
    },
  },
});
</script>
